import styled from 'styled-components'

export const Container = styled.div`
    display:flex;
    flex-direction: column;
    color: #FFF;
    margin: 0;
    width: 100%;
    padding: 0;
    @media (min-width: 768px) { 
        width: 100%;
  
    @media (min-width: 992px) { 
        width: 100%;
       
    }
    @media (min-width: 1200px) { 
        width: 100%;
       
    }
    #isdivs{
        background: #fff;
        padding: 20px;
        border-radius: 5px;
    }
`

export const DivPreguntas = styled.div`
    color:#000;
    font-size:12px;
    margin-bottom:30px;
    margin-top:10px;
`

export const FormContainer = styled.div`
    text-align: center;
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background: rgba(255,255,255,.9);
    @media (min-width: 768px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 0;
        height: 100vh;
    }
    @media (min-width: 992px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 50%;
        height: auto;
    }
    @media (min-width: 1200px) { 
        margin-top: 0;
        margin-right: 0;
        margin-left: 50%;
        height: auto;
    }
`

export const Label = styled.label`
    display:flex;
    color:#D9A76A;
    font-size:14px;
    margin-bottom:10px;

    @media (min-width: 768px) { 
        
    }
    @media (min-width: 992px) { 
       
    }
    @media (min-width: 1200px) { 
        
    }
       
`
export const Col = styled.div`
    display: flex;
    margin: 20px 0;
    justify-content: flex-start;
    align-items: center;
    @media (min-width: 768px) { 

    }
    @media (min-width: 992px) { 

    }
    @media (min-width: 1200px) { 

    }

    .btn{
        margin-right:10px;
        font-size: 12px;
        padding: 5px 10px;
    }
`

export const LoginNotice = styled.div`
    color:#f33;
    font-size:12px;
    margin-bottom:20px;
    margin-top:20px;
`

export const Textarea = styled.textarea`
    width:100%;
    padding: 20px;
`

export const Btnpreguntar = styled.div`
    background: #D9A76A;
    color: #fff;
    margin-left: 0px;
    border-radius: 4px;
    border: #D9A76A solid 1px;
    display: inline-flex;
    text-transform: uppercase;
    cursor: pointer;
    margin-right: 13px;
    font-size: 14px;
    padding: 8px 14px;

    &:hover{
        opacity:.8;
    }
`

export const Btncancelar = styled.div`
    background: #fff;
    color: #43425D;
    margin-left: 0px;
    border-radius: 4px;
    border: #43425D solid 1px;
    display: inline-flex;
    text-transform: uppercase;
    cursor: pointer;
    margin-right: 13px;
    font-size: 14px;
    padding: 8px 14px;

    &:hover{
        opacity:.8;
    }
`

export const Containerp = styled.div`
    background: #fff;
    border-radius: 0px;
    margin: 30px 0;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

   @media (min-width: 768px) {
    border-radius: 5px;
    width: 100%;
   }
`
 

export const HeaderListp = styled.div`
   flex-wrap: wrap;
   display: flex;
   width: 100%;
   padding: 20px 20px 10px 20px;
   border-bottom: solid 2px #F6F6F6;
   @media (min-width: 768px) { 
      padding: 20px;
    }
    @media (min-width: 992px) { 
      padding: 20px;
    }
    @media (min-width: 1200px) { 
      padding: 20px;
    }
`


export const Pregunta = styled.div`
    margin: 15px 20px 15px 20px;
    font-size:12px;
    border-bottom: #ccc solid 1px;

`

export const Titulop = styled.div`
   

`

export const Respuesta = styled.div`
    margin: 10px 20px;
    font-size:12px;
    color:#D9A76A;

`
 